import { takeLatest, put, call } from 'redux-saga/effects';

import { listCatalagoProdutoWhiteLabel } from '../service';
import {
  TABLE_CATALAGO_PRODUTO_WHITE_LABEL,
  TABLE_CATALAGO_PRODUTO_WHITE_LABEL_PENDING,
  TABLE_CATALAGO_PRODUTO_WHITE_LABEL_SUCCESS,
  TABLE_CATALAGO_PRODUTO_WHITE_LABEL_FAILURE
} from '../actionTypes';

function* sagaListCatalagoProdutoWhiteLabel(action) {
  yield put({ type: TABLE_CATALAGO_PRODUTO_WHITE_LABEL_PENDING })

  try {
    const table = yield call(listCatalagoProdutoWhiteLabel, action.args)
    yield put({ type: TABLE_CATALAGO_PRODUTO_WHITE_LABEL_SUCCESS, table: table })

  } catch (error) {

    yield put({ type: TABLE_CATALAGO_PRODUTO_WHITE_LABEL_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListCatalagoProdutoWhiteLabel() {
  yield takeLatest(TABLE_CATALAGO_PRODUTO_WHITE_LABEL, sagaListCatalagoProdutoWhiteLabel)
}